import { MenuItem, TextField } from "@mui/material";
import { Form, Options } from "../../interfaces/forms";
import { Controller, useFormContext } from "react-hook-form";

interface SelectFormProps {
  field: Form;
}
function SelectForm(props: SelectFormProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={props.field.name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          select
          label={props.field.label}
          sx={{ width: "100%" }}
          error={!!errors[props.field.name]}
          helperText={
            errors[props.field.name]
              ? (errors[props.field.name]?.message as string)
              : ""
          }
        >
          {props.field.options &&
            props.field.options.map((option: Options) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
        </TextField>
      )}
    />
  );
}

export default SelectForm;
